const hueName = hue => {
  if (hue === undefined) {
    return 'gray';
  }

  hue = Math.round(hue - 20 + 360) % 360;

  return [
    'red',
    'orange',
    'lime',
    'green',
    'teal',
    'cyan',
    'blue',
    'purple',
    'magenta'
  ][Math.floor((hue / 360) * 9)];
};

module.exports = hueName;
